"use strict";
exports.INPUT_MODE_REGEX = /^(<|=|@)?(\??)(\w*)$/;
exports.BINDING_MODE = Object.freeze({
    oneWay: '<',
    twoWay: '=',
    output: '&',
    attr: '@',
    optional: '?'
});
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-metadata/src/core/directives/binding/constants.js
// module id = 44
// module chunks = 0